import { FeatureType, Feature, MeterType } from '@stigg-types/apiTypes';

export function isMetered(feature: Pick<Feature, 'featureType' | 'meterType'>) {
  return (
    feature.featureType === FeatureType.Number &&
    (feature.meterType === MeterType.Fluctuating || feature.meterType === MeterType.Incremental)
  );
}
